import { useReport } from "./useReport";
import { TierIiReportOrgStatus } from "generated-graphql/graphql";

/**
 * A hook that determines if the current Tier II report is in a verified state.
 *
 * @returns {boolean} Returns true if the organization's Tier II report status is 'Verified',
 *                    indicating the report is in display-only mode. Returns false otherwise.
 *
 * @example
 * ```tsx
 * const isVerified = useReportIsVerified();
 * if (isVerified) {
 *   // Handle verified mode
 * }
 * ```
 */

export function useReportIsVerified() {
  const { data } = useReport();
  return (
    data?.tierIIReport.organizationStatus === TierIiReportOrgStatus.Verified
  );
}
